export default __webpack_public_path__ + "static/media/mobile-alt-solid.06baca71.svg";